(function () {
  'use strict';

  function initDrawers() {
    document.querySelectorAll('[data-wemai-drawer]').forEach(function (drawer) {
      var id = drawer.getAttribute('data-wemai-drawer');
      var openers = document.querySelectorAll('[data-wemai-drawer-open="' + id + '"]');
      var closers = drawer.querySelectorAll('[data-wemai-drawer-close="' + id + '"]');
      var overlay = document.querySelector('[data-wemai-drawer-overlay="' + id + '"]');

      function open() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.classList.add('is-open');
        document.body.classList.add('wemai-drawer-open');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      }

      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) overlay.classList.remove('is-open');
        document.body.classList.remove('wemai-drawer-open');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      }

      openers.forEach(function (o) { o.addEventListener('click', open); });
      closers.forEach(function (c) { c.addEventListener('click', close); });
      if (overlay) overlay.addEventListener('click', close);

      drawer.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  function initAnnouncementRotation() {
    document.querySelectorAll('.wemai-announcement[data-auto-rotate="true"]').forEach(function (bar) {
      var track = bar.querySelector('[data-wemai-announcement-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.wemai-announcement__slide');
      if (slides.length < 2) return;
      var speed = (parseInt(bar.getAttribute('data-rotate-speed'), 10) || 5) * 1000;
      var current = 0;

      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, speed);
    });
  }

  function initSearch() {
    document.querySelectorAll('[data-wemai-search-panel]').forEach(function (panel) {
      var header = panel.closest('[data-wemai-header]');
      if (!header) return;
      var toggles = header.querySelectorAll('[data-wemai-search-toggle]');
      var closers = panel.querySelectorAll('[data-wemai-search-close]');
      var input = panel.querySelector('[data-wemai-search-input]');

      function open() {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
        if (input) setTimeout(function () { input.focus(); }, 50);
      }

      function close() {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }

      toggles.forEach(function (t) {
        t.addEventListener('click', function () {
          if (panel.classList.contains('is-open')) close(); else open();
        });
      });
      closers.forEach(function (c) { c.addEventListener('click', close); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
      });

      document.addEventListener('click', function (e) {
        if (!panel.classList.contains('is-open')) return;
        if (panel.contains(e.target)) return;
        var clickedToggle = false;
        toggles.forEach(function (t) { if (t.contains(e.target)) clickedToggle = true; });
        if (clickedToggle) return;
        close();
      });
    });
  }

  function init() {
    initDrawers();
    initSearch();
    initAnnouncementRotation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
